import { useEffect, useState } from 'react';

export const useFetchChartData = (
  fetchFunction,
  dependencies = [],
  fetchAvailableRanges = null
) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [availableRanges, setAvailableRanges] = useState([]);
  const [upperLimit, setUpperLimit] = useState<number | null>(null);
  const [lowerLimit, setLowerLimit] = useState<number | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await fetchFunction();
        setData(result.data);
        setUpperLimit(result.upperLimit);
        setLowerLimit(result.lowerLimit);
        if (fetchAvailableRanges) {
          const ranges = await fetchAvailableRanges();
          setAvailableRanges(ranges);
        }
      } catch (err) {
        setError(err);
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, dependencies);

  return { data, lowerLimit, upperLimit, loading, error, availableRanges };
};
